import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-headimg',
  templateUrl: './headimg.component.html',
  styleUrls: ['./headimg.component.css']
})
export class HeadimgComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
